// import { modifyPointCloud } from "api/timeline";
// import { getPointCloudData } from "pages/unity/domain/getPointCloudData";

const colorDropdownConfig = {
  modifyPointCloud: () => null,
  getPointCloudData: () => null
};

export default colorDropdownConfig;